import { AfterViewInit, Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[nrwlRxCharactersDownCounter]',
})
export class RxCharactersDownCounterDirective implements AfterViewInit {
  @Input('nrwlRxCharactersDownCounter') count;
  @Input('setHeight') height = '100px';
  @Input('ddFontSize') fontSize = '19px';
  private remindCharacters = 0;
  private remindSpan: HTMLSpanElement;

  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit(): void {
    const parentBlockHtml = this.elementRef.nativeElement.parentElement;
    if (this.count && this.count > 0 && !!parentBlockHtml) {
      this.remindCharacters = this.count;
      parentBlockHtml.style.position = 'relative';
      this.elementRef.nativeElement.style.resize = 'none';
      this.elementRef.nativeElement.style.height = this.height;
      this.elementRef.nativeElement.style.paddingRight = '3rem';
      this.remindSpan = document.createElement('span');
      this.remindSpan.innerHTML = this.count;
      this.setRemindStyles();

      this.elementRef.nativeElement.insertAdjacentElement('afterend', this.remindSpan);
      this.calculateRemind(this.elementRef.nativeElement.value);
    }
  }

  private setRemindStyles() {
    this.remindSpan.style.color = 'gray';
    this.remindSpan.style.fontSize = this.fontSize;
    this.remindSpan.style.position = 'absolute';
    this.remindSpan.style.right = '0.8rem';
    this.remindSpan.style.bottom = '0.8rem';
    this.remindSpan.style.fontWeight = '300';
    this.remindSpan.style.letterSpacing = '2px';
  }

  private calculateRemind(text: string) {
    this.remindCharacters = this.count - text.length;
    this.remindSpan.innerHTML = this.remindCharacters.toString();
  }

  @HostListener('input', ['$event']) onInput(event) {
    const text: string = event.target.value;
    if (!!this.remindSpan) {
      this.calculateRemind(text);
      if (text.length >= this.count) {
        this.remindSpan.innerHTML = '0';
        event.target.value = text.substr(0, this.count);
        this.remindSpan.style.color = 'red';
        setTimeout(() => {
          this.remindSpan.style.color = 'gray';
        }, 500);
      }
    }
  }
}
